import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import type { Skill } from '~/shared/data-contract/skill';

import { SmallText } from '../../../../../design/components/Typography';
import { useSkillProficiencyLevelName } from '../../../../common/skills';
import { SkillChipWithDrawer } from '../../../../common/skills/SkillChipWithDrawer';

type LanguageListProps = {
    readonly languageList: readonly Skill[] | undefined;
};
export const LanguageList: FunctionComponent<LanguageListProps> = (props) => {
    const { getProficiencyLevelName } = useSkillProficiencyLevelName();

    if (!is.array(props.languageList) || !is.nonEmptyArray(props.languageList)) {
        return null;
    }

    return (
        <List
            className="language-list"
            disablePadding={true}
            sx={{
                '&:not(:last-child)': {
                    borderBottom: '1px solid',
                    borderBottomColor: (theme) => theme.palette.cardborder.main,
                },
            }}
        >
            {props.languageList.map((language) => (
                <ListItem
                    key={language.id}
                    sx={{
                        '&:not(:last-child)': {
                            borderBottom: '1px solid',
                            borderBottomColor: (theme) => theme.palette.cardborder.main,
                        },
                        alignItems: 'center',
                        display: 'flex',
                        gap: (theme) => theme.spacing(2),
                        gridTemplateColumns: `40% minmax(0px, 3fr) repeat(2, minmax(0, 2fr)) 1fr`,
                        justifyContent: 'space-between',
                        paddingBlock: (theme) => theme.spacing(1),
                        paddingInline: (theme) => theme.spacing(3),
                    }}
                >
                    <SkillChipWithDrawer
                        isSynced={language.isSynced}
                        label={language.title}
                        skillId={language.id}
                        type={language.skillType}
                    />
                    <SmallText>{getProficiencyLevelName(language)}</SmallText>
                </ListItem>
            ))}
        </List>
    );
};
